import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';

@Component({
    selector: 'button[inlineButton], a[inlineButton], button[actionInline]. a[actionInline], span[inlineButton], span[actionInline]',
    templateUrl: 'inline-button.html',
    styleUrls: ['inline-button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineButtonComponent extends AbstractButtonComponent {
    // This input is just to make compiler happy.
    @Input()
    inlineButton?: any;

    @Input()
    actionInline?: any;

    protected variantInputName = undefined;
}
